import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';


import {ACCOUNT_TABS} from 'src/constants';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {SecondaryTabs, Tab} from '@pb/kit-component-tabs-v2';
import {useGateValue} from '@pb/kit-lib-statsig';

import {ENTITLEMENTS_SUB_TABS} from './constants';

import {entitlementsSubTabTabs} from './entitlements-subtab.module.styl';

type Props = {
    accountId: number,
    activeSubTab: string,
};

export const EntitlementsTabBar = ({accountId, activeSubTab}: Props) => {
    const navigate = useNavigate();
    const isDatasetEnabled = useGateValue(STATSIG_GATES.DATASET_ENTITLEMENTS);
    const {accountTabChange} = useEventTracking();

    const setActiveTab = useCallback((tab: string) => {
        accountTabChange({activeTab: tab, previousTab: activeSubTab});
        navigate(
            `/profile/account/${accountId}/${ACCOUNT_TABS.ENTITLEMENTS.name}/${tab}`,
        );
    }, [accountId, navigate, activeSubTab, accountTabChange]);

    return (
        <SecondaryTabs value={activeSubTab} onChange={setActiveTab} className={entitlementsSubTabTabs} style={{width: '100%'}}>
            <Tab
                key={ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS.name}
                value={ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS.name}
                {...ENTITLEMENTS_SUB_TABS.ACCOUNT_ENTITLEMENTS}
            />
            <Tab
                key={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}
                value={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}
                {...ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS}
            />
            {isDatasetEnabled ? (
                <Tab
                    value={ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS.name}
                    {...ENTITLEMENTS_SUB_TABS.DATASET_ENTITLEMENTS}
                />
            ) : null}
        </SecondaryTabs>
    );
};
